// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.auth.HpApiAuthenticationV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  HpApiResponseDto,
  HpAppleAuthRequestDto,
  HpAuthFlowRequestDto,
  HpAuthFlowResponseDto,
  HpFreepassAuthRequestDto,
  HpGoogleAuthRequestDto,
  HpOtpSendAuthRequestDto,
  HpOtpVerifyAuthRequestDto,
  HpUserCredentialsDto,
} from '../..';

export const HpApiAuthenticationV3Handler_apple_Path = '/api/web/v3/user/auth/apple';

/**
 * Sign in with an Apple ID token
 */
export const HpApiAuthenticationV3Handler_apple = (postData: HpAppleAuthRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpAppleAuthRequestDto, HpApiResponseDto<HpUserCredentialsDto>>(
    {
      endpoint: HpApiAuthenticationV3Handler_apple_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_flow_Path = '/api/web/v3/user/auth/flow';

/**
 * Returns the auth flow for the client to route the user to the correct sign-in step
 */
export const HpApiAuthenticationV3Handler_flow = (postData: HpAuthFlowRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpAuthFlowRequestDto, HpApiResponseDto<HpAuthFlowResponseDto>>(
    {
      endpoint: HpApiAuthenticationV3Handler_flow_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_freepass_Path = '/api/web/v3/user/auth/freepass';

/**
 * Redeem a freepass email-link token
 */
export const HpApiAuthenticationV3Handler_freepass = (postData: HpFreepassAuthRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpFreepassAuthRequestDto, HpApiResponseDto<HpUserCredentialsDto>>(
    {
      endpoint: HpApiAuthenticationV3Handler_freepass_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_google_Path = '/api/web/v3/user/auth/google';

/**
 * Sign in with a Google ID token
 */
export const HpApiAuthenticationV3Handler_google = (postData: HpGoogleAuthRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpGoogleAuthRequestDto, HpApiResponseDto<HpUserCredentialsDto>>(
    {
      endpoint: HpApiAuthenticationV3Handler_google_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_logout_Path = '/api/web/v3/user/auth/logout';

/**
 * Log out: clear session cookies and reset to an anonymous session
 */
export const HpApiAuthenticationV3Handler_logout = (client = getClient()) => {
  return httpApiRequest<never, never, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiAuthenticationV3Handler_logout_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_otp_Path = '/api/web/v3/user/auth/otp';

/**
 * Redeem a one-time sign-in code
 */
export const HpApiAuthenticationV3Handler_otp = (postData: HpOtpVerifyAuthRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpOtpVerifyAuthRequestDto, HpApiResponseDto<HpUserCredentialsDto>>(
    {
      endpoint: HpApiAuthenticationV3Handler_otp_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiAuthenticationV3Handler_sendOtp_Path = '/api/web/v3/user/auth/sendOtp';

/**
 * Send a one-time sign-in code email
 */
export const HpApiAuthenticationV3Handler_sendOtp = (postData: HpOtpSendAuthRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpOtpSendAuthRequestDto, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiAuthenticationV3Handler_sendOtp_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
